import React from "react";
import {Colors} from "../assets/colors/Colors";
import {validStateChecked} from "./Switch";


const IndicadorEstado = ({state, width = 20, height = 20}) => {

  return(
    <div className="d-flex justify-content-center align-items-center h-100">
      {
        validStateChecked(state)
        ? <div style={{backgroundColor: Colors.GREEN_SWITCH_ACTIVE, width, height, borderRadius: 10}}/>
        : <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE, width, height, borderRadius: 10}}/>
      }
    </div>
  )

}

export default IndicadorEstado;
